module.exports = __webpack_public_path__ + "static/media/bg-06.e432c1d3.png";